export default __webpack_public_path__ + "static/media/business-288c.d606d10c.jpg";